import { render } from "./SinglePortfolio.vue?vue&type=template&id=090e062c&scoped=true"
import script from "./SinglePortfolio.vue?vue&type=script&lang=js"
export * from "./SinglePortfolio.vue?vue&type=script&lang=js"

import "./SinglePortfolio.vue?vue&type=style&index=0&id=090e062c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090e062c"]])

export default __exports__